module.exports = __webpack_public_path__ + "static/media/ata.b0a5d75c.png";